import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();
  const { generalSettings } = useSelector((state) => state.settings);

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-1 d-flex flex-lg-column rounded-fix mx-5 my-2 mt-5 ${layoutProps.footerClasses}`}
      id="kt_footer">
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column-reverse flex-lg-row align-items-center justify-content-between text-center`}>
        <div className="text-dark font-size-sm order-md-1">
          <span>{today.toString()}</span> &copy;{" "}
          <span>{generalSettings?.siteName}. All rights reserved.</span>
        </div>
        <div className="nav d-flex align-items-center justify-content-center nav-dark order-1 order-md-2">
          <span className="me-1 font-size-sm">Powered by:</span>
          <a
            href={import.meta.env.VITE_POWERED_BY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link d-flex fw-bolder font-size-sm text-black fst-italic pe-3 ps-0">
            <span className="svg-icon svg-icon-warning d-block me-1">
              <SVG
                src={toAbsoluteUrl(
                  "media/svg/icons/NewDashboard/fs-logo-icon.svg"
                )}></SVG>
            </span>
            {import.meta.env.VITE_POWERED_BY_NAME}
          </a>
        </div>
      </div>
    </div>
  );
}
